var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVerifyBadge = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "VerifiedBadge"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20,12 C20,13.0161224 18.8228437,13.7906306 18.4564315,14.6740996 C18.076716,15.5900035 18.3470907,16.96671 17.656837,17.656837 C16.96671,18.3470907 15.5898768,18.076716 14.6740996,18.4565582 C13.7906306,18.8229704 13.0159957,20 12,20 C10.9840043,20 10.2093694,18.8229704 9.32590035,18.4565582 C8.40999652,18.076716 7.03329004,18.3470907 6.34316303,17.656837 C5.65290932,16.9665833 5.92328403,15.5900035 5.54344177,14.6740996 C5.17715625,13.7906306 4,13.0161224 4,12 C4,10.9840043 5.17715625,10.2093694 5.54356846,9.32602705 C5.92328403,8.40999652 5.65303601,7.03341674 6.34316303,6.34316303 C7.03341674,5.65290932 8.40999652,5.92328403 9.32590035,5.54356846 C10.2093694,5.17715625 10.9840043,4 12,4 C13.0159957,4 13.7906306,5.17715625 14.6740996,5.54356846 C15.5900035,5.92328403 16.96671,5.65290932 17.656837,6.34328973 C18.3470907,7.03341674 18.076716,8.41012321 18.4564315,9.32602705 C18.8228437,10.2093694 20,10.9840043 20,12",
  id: "Fill-1",
  fill: "#1891FF"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path-326",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  points: "14.6057422 8.36803329 16.1557332 9.63196671 11.3475836 15.5283128 8.4085394 13.3724703 9.5914606 11.7598025 10.9983913 12.7918118"
})))));
export { SvgVerifyBadge as ReactComponent };
export default __webpack_public_path__ + "static/media/verifyBadge.b9234e04.svg";